exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-qualified {\n  background-color: #00ff8f;\n}\n.loading-loader {\n  text-align: center;\n  position: absolute;\n  color: #fff;\n  z-index: 9;\n  background: #01b1af;\n  padding: 8px 18px;\n  border-radius: 5px;\n  left: calc(50% - 45px);\n  top: calc(50% - 18px);\n}\n.white-overlay {\n  background-color: hsla(0, 0%, 100%, .75);\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  margin: 0;\n}\n#saleBehaviorContacts {\n  overflow: scroll;\n  height: 800px;\n}\n", ""]);

// exports
